export const PM_USERS_FORCE_LOGOUT_OPEN_MODAL = "PM_USERS_FORCE_LOGOUT_OPEN_MODAL";
export const PM_USERS_FORCE_LOGOUT_REQUEST = "PM_USERS_FORCE_LOGOUT_REQUEST";
export const PM_USERS_FORCE_LOGOUT_RESULT = "PM_USERS_FORCE_LOGOUT_RESULT";